import Turbolinks from "turbolinks"

const THRESHOLD = 80
const MAX_PULL = 120
const RESISTANCE = 0.5

let startY = 0
let currentY = 0
let pulling = false
let indicator = null
let stylesInjected = false

function injectStyles() {
  if (stylesInjected) return
  stylesInjected = true

  const style = document.createElement("style")
  style.textContent = `
    #ptr-indicator {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 0;
      overflow: visible;
      z-index: 99999;
      pointer-events: none;
    }
    #ptr-indicator .ptr-spinner {
      width: 36px;
      height: 36px;
      border: 3px solid rgba(225, 78, 202, 0.2);
      border-top-color: #e14eca;
      border-radius: 50%;
      background: #27293d;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
      transform: translateY(-50%) scale(0);
      transition: transform 0.2s ease;
    }
    #ptr-indicator .ptr-spinner.visible {
      transform: translateY(0) scale(1);
    }
    #ptr-indicator .ptr-spinner.spinning {
      animation: ptr-spin 0.6s linear infinite;
    }
    @keyframes ptr-spin {
      to { transform: translateY(0) scale(1) rotate(360deg); }
    }
  `
  document.head.appendChild(style)
}

function ensureIndicator() {
  if (indicator && document.body.contains(indicator)) return indicator

  injectStyles()
  indicator = document.createElement("div")
  indicator.id = "ptr-indicator"
  indicator.innerHTML = `<div class="ptr-spinner"></div>`
  document.body.appendChild(indicator)
  return indicator
}

function scrollTop() {
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  )
}

function onTouchStart(event) {
  if (scrollTop() > 5) return
  startY = event.touches[0].clientY
  currentY = startY
  pulling = true
  ensureIndicator()
}

function onTouchMove(event) {
  if (!pulling) return
  if (scrollTop() > 5) {
    pulling = false
    return
  }

  currentY = event.touches[0].clientY
  const diff = currentY - startY
  if (diff < 0) {
    pulling = false
    return
  }

  const pullDistance = Math.min(diff * RESISTANCE, MAX_PULL)
  const ind = ensureIndicator()
  const spinner = ind.querySelector(".ptr-spinner")

  ind.style.height = `${pullDistance}px`
  spinner.classList.toggle("visible", pullDistance > 15)
  spinner.classList.toggle("spinning", pullDistance >= THRESHOLD)
}

function onTouchEnd() {
  if (!pulling) return
  pulling = false

  const diff = currentY - startY
  const pullDistance = Math.min(diff * RESISTANCE, MAX_PULL)
  const ind = ensureIndicator()
  const spinner = ind.querySelector(".ptr-spinner")

  if (pullDistance >= THRESHOLD) {
    ind.style.height = "60px"
    Turbolinks.visit(window.location.href, { action: "replace" })
    setTimeout(() => {
      spinner.classList.remove("visible", "spinning")
      ind.style.height = "0"
    }, 800)
  } else {
    spinner.classList.remove("visible", "spinning")
    ind.style.height = "0"
  }
}

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  )
}

export function initPullToRefresh() {
  if (!isStandalone()) return

  document.addEventListener("touchstart", onTouchStart, { passive: true })
  document.addEventListener("touchmove", onTouchMove, { passive: true })
  document.addEventListener("touchend", onTouchEnd, { passive: true })
}
